<template>
  <!-- 応募案件詳細案件 -->
  <div class="loading" v-if="loading">
    <img src="../assets/loading.gif" />
  </div>

  <div class="project-detail" v-if="!loading">
    <div class="state-condition">
      <div
        v-for="(item, index) in statusList()"
        :key="index"
        :class="[
          detail.aplication_state == item.index
            ? 'current_status__list'
            : 'status__list',
        ]"
      >
        <img
          src="../assets/check.svg"
          v-if="
            detail.aplication_state > item.index ||
            detail.aplication_state == APPLICATION_STATE.DONE ||
            detail.aplication_state == APPLICATION_STATE.REJECTED ||
            detail.aplication_state == APPLICATION_STATE.CANCELED
          "
        />
        <img
          src="../assets/current-status.svg"
          :class="[
            detail.aplication_state != APPLICATION_STATE.DONE &&
            detail.aplication_state != APPLICATION_STATE.REJECTED &&
            detail.aplication_state != APPLICATION_STATE.CANCELED
              ? 'current__status'
              : '',
          ]"
          v-else-if="detail.aplication_state == item.index"
        />
        <img src="../assets/circle.svg" v-else /><span>{{ item.title }}</span>
        <div
          :class="[
            detail.aplication_state > item.index
              ? 'done'
              : APPLICATION_STATE.DONE == item.index ||
                APPLICATION_STATE.REJECTED == item.index ||
                APPLICATION_STATE.CANCELED == item.index
              ? ''
              : 'undone',
          ]"
        >
          <div v-if="detail.aplication_state == item.index">
            <p class="status-message">{{ item.message }}</p>
            <common-button
              :data="{
                status: 5,
                button: item.greyButton,
              }"
              style="height: 44px; width: 290px"
              @click="clickGreyButton(item.index)"
              v-if="item.greyButton && showGreyButton(item.index)"
            ></common-button>
            <common-button
              :data="{
                status: 5,
                button: '下書きをプレビューする',
              }"
              style="height: 44px; width: 290px"
              @click="preview()"
              v-if="
                detail.aplication_state == APPLICATION_STATE.BEFORE_POST &&
                detail.media_type != MEDIA_TYPE.YOUTUBE &&
                detail.is_needed_review
              "
            ></common-button>
            <common-button
              :data="{
                status: 5,
                button: '前回提出済下書きをプレビューする',
              }"
              style="height: 44px; width: 290px"
              @click="preview()"
              v-if="
                detail.aplication_state == APPLICATION_STATE.WRITING_DRAFT &&
                detail.media_type != MEDIA_TYPE.YOUTUBE &&
                detail.is_needed_review &&
                detail.draft
              "
            ></common-button>
            <common-button
              :data="{
                status: 3,
                button: item.button,
              }"
              style="height: 44px; width: 290px"
              @click="confirm(item.index)"
              v-if="item.button && detail.aplication_state != APPLICATION_STATE.APPLIED"
            ></common-button>
            <!-- 応募済、募集期間終了後はキャンセルできないようにする -->
            <common-button
              :data="{
                status: 3,
                button: item.button,
              }"
              style="height: 44px; width: 290px"
              @click="confirm(item.index)"
              v-else-if="item.button && (detail.aplication_state == APPLICATION_STATE.APPLIED) && new Date(detail.entry_ended_at) > new Date()"
            ></common-button>
          </div>
          <div v-else style="height: 24px"></div>
        </div>
      </div>
    </div>
    <div class="list__item__area">
      <div
        v-for="(item, index) in displayMenuList()"
        :key="index"
        @click="push(index)"
        class="list__item"
      >
        <p>{{ item.name }}</p>
        <img class="detail_icon" src="../assets/detail.svg" align="right" />
      </div>
    </div>
    <div
      class="footer"
      :style="[
        showDialog || showContactDialog ? 'z-index: 99;' : 'z-index: 9999;',
      ]"
    >
      <common-button
        :data="{
          status: 3,
          button: `お問い合わせ`,
        }"
        @click="openContactDialog()"
        v-if="!isEntryEnd"
      ></common-button>
    </div>
  </div>
  <comfirm-dialog
    ref="dialog"
    v-model="showDialog"
    :message="message"
    :button="button"
    :sub-message="subMessage"
    :place-folder="MEDIA_LINK[detail.media_type]"
    :show-text-field="showTextField"
    :submit-url="submitUrl"
    @apply="updateStatus($event)"
  ></comfirm-dialog>
  <contact-dialog
    ref="contactDialog"
    v-model="showContactDialog"
    :projectId="detail.id"
  ></contact-dialog>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from "vue";
import ComfirmDialog from "./ComfirmDialog.vue";
// import Toast from "./Toast.vue";
import CommonButton from "./CommonButton.vue";
import ContactDialog from "./ContactDialog.vue";
import { CommonStore } from "../store/CommonStore";

// import liff from "@line/liff";
import { useRouter } from "vue-router";
import {
  APPLICATION_STATE,
  MEDIA_TYPE,
  PROJECT_STATUS,
  MEDIA_LINK,
  BASEURL,
} from "../consts/common";
import { ProjectStore } from "../store/ProjectStore";
import { projects } from "../types/apiResponse";
// import liff from "@line/liff";

const dialog = ref<InstanceType<typeof ComfirmDialog>>();
const contactDialog = ref<InstanceType<typeof ContactDialog>>();
const router = useRouter();
// const store = ProjectStore();
const omiStore = ProjectStore();
const commonStore = CommonStore();
const loading = ref(false);
const message = ref("");
const subMessage = ref("");

const showDialog = ref(false);
const showContactDialog = ref(false);
const button = ref("");
const isEntryEnd = ref(false);
// const updateState = ref(false);
const showTextField = ref(false);
const submitUrl = ref("");
const menuList = [
  { name: "案件詳細", page: "/project-detail" },
  { name: "三条書面確認", page: "/document" },
  { name: "下書き確認", page: "/review-draft" },
  { name: "前回提出済下書き確認", page: "/review-draft" },
];
const detail = ref<projects>({
  aplication_state: 0,
  banner: {
    message: "案件に応募するためにはプロフィール登録が必要です",
    target: "sign-up",
  },
  client: {
    id: 0,
    name: "",
  },
  confirm_deadline: "",
  description: "",
  draft: null,
  document_url: "",
  entry_ended_at: "",
  entry_started_at: "",
  entry_state: 0,
  has_shipment: false,
  hashtag: "",
  id: -1,
  image: "",
  is_favorited: false,
  is_needed_review: false,
  is_offer: false,
  link_url: "",
  media_type: 0,
  min_follower_count: 0,
  note: "",
  orientation_url: "",
  outsourcing_amount: 0,
  payment_due_date: "投稿月の翌月末",
  post_ended_at: "",
  post_started_at: "",
  products: [
    {
      brand_name: "",
      brand_name_kana: "",
      description: "",
      id: 0,
      manufacturer_name: "",
      name: "",
      url: "",
    },
  ],
  prohibitions: [],
  recruitment_numbers: 0,
  state: 0,
  title: "",
});

// 確認ダイアログを表示する
const confirm = (index: number) => {
  if (index == APPLICATION_STATE.APPLIED) {
    showDialog.value = true;
    message.value = "この案件への応募を取り消しますか?";
    subMessage.value = `取り消し後も案件の募集期間内であれば\n再度応募することができます`;
    button.value = "応募を取り消す";
    showTextField.value = false;
    dialog.value?.openDialog();
    // 商品受け取り
  } else if (index == APPLICATION_STATE.WAITING_FOR_ITEM) {
    showDialog.value = true;
    message.value = "商品受取完了";
    subMessage.value = `案件に使用する商品がご自宅に届きましたら\n商品の受取ボタンをタップしてください`;
    button.value = "商品を受け取りました";
    showTextField.value = false;
    dialog.value?.openDialog();
    // 下書き入力
  } else if (index == APPLICATION_STATE.WRITING_DRAFT) {
    // youtubeの場合はurl入力画面、その他はファイルアップロード画面
    if (detail.value.media_type == MEDIA_TYPE.YOUTUBE) {
      // router.push("/draft")
      router.push({ name: "draft", query: { mediaType: MEDIA_TYPE.YOUTUBE } });
    } else {
      // 下書き再提出の場合は再度アップロードしてもらう
      if (detail.value.draft) {
        // // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // const urlList: { url: string; display: string; file: any; }[] = []
        // detail.value.draft.resouces.forEach((v) => urlList.push({ url: v.url, display: v.url, file: "image/png" }))
        // omiStore.fileUploadList.set(detail.value.id, urlList)
        omiStore.setFileUploadList(detail.value.id, []);
      }
      // 下書き再提出であれば提出済の内容をstoreに保存
      omiStore.setDraftBeforeChecked(detail.value.draft?.content || "")
      router.push("upload-file")
      // router.push({
      //   name: "upload-file",
      //   query: { content: detail.value.draft?.content || "" , projectId: omiStore.selectedId || 0},
      // });
    }
    // 投稿完了
  } else if (index == APPLICATION_STATE.BEFORE_POST) {
    // submitUrl.value = detail.value.draft?.url || ""
    message.value = "投稿完了";
    button.value = "投稿が完了しました";
    showTextField.value = true;
    subMessage.value = "投稿したURLを入力してください";
    submitUrl.value = detail.value.draft?.url || "";
    showDialog.value = true;
    dialog.value?.openDialog();

    // キャンセル済
  } else if (index == APPLICATION_STATE.CANCELED) {
    router.push("project-detail");
    // 投稿完了
  } else return;
};

function showGreyButton(index: number) {
  // if (index != APPLICATION_STATE.BEFORE_POST) return true
  // if (!detail.value.is_needed_review) return false
  // return true

  if (index == APPLICATION_STATE.BEFORE_POST) {
    if (
      !detail.value.is_needed_review ||
      detail.value.media_type == MEDIA_TYPE.YOUTUBE
    )
      return false;
    else return true;
  }
}

function clickGreyButton(index: number) {
  // 下書き確認があった場合にコピーできる
  if (index == APPLICATION_STATE.BEFORE_POST && detail.value.is_needed_review) {
    navigator.clipboard.writeText(detail.value.draft?.content || "");
    commonStore.setToast({
      showToast: true,
      message: "下書きをコピーしました",
      state: 0,
      timeout: 2000,
    });
  } else if (index == APPLICATION_STATE.WAITING_FOR_PAID) {
    // 口座登録してなかったら口座登録画面に遷移する
    router.push("/bank-detail");
  } else if (index == APPLICATION_STATE.DONE) {
    router.back();
    omiStore.setSelectedTab(0);
  }
}
// 下書きをプレビューする
function preview() {
  const urlList: string[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  detail.value.draft?.resouces.forEach((v: any) => {
    urlList.push(v.url);
  });
  if (detail.value.draft)
    router.push({
      name: "preview-draft",
      query: {
        resouces: JSON.stringify(detail.value.draft?.resouces),
        content: detail.value.draft.content,
      },
    });
}

function displayMenuList(): { name: string; page: string }[] {
  if (
    detail.value.aplication_state > APPLICATION_STATE.DONE ||
    detail.value.aplication_state < APPLICATION_STATE.WON
  )
    return [menuList[0]];
  else if (
    detail.value.is_needed_review &&
    detail.value.media_type != MEDIA_TYPE.YOUTUBE &&
    detail.value.aplication_state >= APPLICATION_STATE.CHECK_DRAFT
  )
    return [menuList[0], menuList[1], menuList[2]];
  // 下書き再提出になった場合は前回提出分の下書きを表示する
  else if (
    detail.value.is_needed_review &&
    detail.value.media_type != MEDIA_TYPE.YOUTUBE &&
    detail.value.aplication_state == APPLICATION_STATE.WRITING_DRAFT &&
    detail.value.draft
  )
    return [menuList[0], menuList[1], menuList[3]];
  else return [menuList[0], menuList[1]];
}

function openContactDialog() {
  showContactDialog.value = true;
  contactDialog.value?.openContactDialog();
}

// 各ステータスごとに表示するステータスリストを変更する
function statusList(): {
  index: number;
  title: string;
  message: string;
  greyButton: string;
  button: string;
}[] {
  if (loading.value) return [];
  const applicationState = detail.value.aplication_state;
  switch (applicationState) {
    // 落選
    // 落選のときは応募済と落選のステータス
    case APPLICATION_STATE.REJECTED:
      return Array.from(PROJECT_STATUS.values()).filter(
        (v) =>
          v.index == APPLICATION_STATE.REJECTED ||
          v.index == APPLICATION_STATE.APPLIED
      );
    // 応募取り消し済み
    // 応募取り消し済の場合は応募取り消し済すてーたすのみ
    case APPLICATION_STATE.CANCELED:
      return Array.from(PROJECT_STATUS.values()).filter(
        (v) => v.index == APPLICATION_STATE.CANCELED
      );
    default:
      if (!detail.value.has_shipment && detail.value.is_needed_review) {
        return Array.from(PROJECT_STATUS.values()).filter(
          (v) =>
            v.index != APPLICATION_STATE.REJECTED &&
            v.index != APPLICATION_STATE.CANCELED &&
            v.index != APPLICATION_STATE.WAITING_FOR_ITEM
        );
      } else if (detail.value.has_shipment && !detail.value.is_needed_review) {
        return Array.from(PROJECT_STATUS.values()).filter(
          (v) =>
            v.index != APPLICATION_STATE.REJECTED &&
            v.index != APPLICATION_STATE.CANCELED &&
            v.index != APPLICATION_STATE.WRITING_DRAFT &&
            v.index != APPLICATION_STATE.CHECK_DRAFT
        );
      } else if (!detail.value.has_shipment && !detail.value.is_needed_review) {
        return Array.from(PROJECT_STATUS.values()).filter(
          (v) =>
            v.index != APPLICATION_STATE.REJECTED &&
            v.index != APPLICATION_STATE.CANCELED &&
            v.index != APPLICATION_STATE.WAITING_FOR_ITEM &&
            v.index != APPLICATION_STATE.WRITING_DRAFT &&
            v.index != APPLICATION_STATE.CHECK_DRAFT
        );
      } else {
        return Array.from(PROJECT_STATUS.values()).filter(
          (v) =>
            v.index != APPLICATION_STATE.REJECTED &&
            v.index != APPLICATION_STATE.CANCELED
        );
      }

    // 商品送付がある場合は発送のステータスを出す
    // if (detail.value.has_shipment) {
    //   return Array.from(PROJECT_STATUS.values()).filter(
    //     (v) => v.index != 10 && v.index != 11
    //   );
    // } else {
    //   return Array.from(PROJECT_STATUS.values()).filter(
    //     (v) => v.index != 10 && v.index != 11 && v.index != 3
    //   );
    // }
  }
}

// 案件応募/キャンセルAPI
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const updateStatus = async (event: string) => {
  loading.value = true;
  if (detail.value.aplication_state == APPLICATION_STATE.APPLIED) {
    const res = await omiStore.cancelProject();
    if (res) {
      await updateProjectDetail();
    }
  } else if (
    detail.value.aplication_state == APPLICATION_STATE.WAITING_FOR_ITEM
  ) {
    const res = await omiStore.receiveProduct();
    if (res) {
      await updateProjectDetail();
    }
  } else if (detail.value.aplication_state == APPLICATION_STATE.BEFORE_POST) {
    // TODO 投稿したurlを入れる
    const param = {
      url: event || "",
    };
    const res = await omiStore.submitPost(param);
    if (res) {
      await updateProjectDetail();
    }
  }
  loading.value = false;
};

function push(index: number) {
  // SNS未登録であればSNS登録画面に遷移、ユーザー登録情報が不足していればユーザー情報更新画面に遷移
  if (!index) {
    router.push("project-detail");
  } else if (index == 1) {
    // 別タブで三条書面表示
    window.open(BASEURL + detail.value.document_url);
  } else {
    preview();
  }
}

onMounted(async () => {
  // loading.value = true;
  // 案件詳細API
  loading.value = true;
  const res = await omiStore.getProjectDetail();

  if (!res) {
    setTimeout(() => {
      commonStore.setToast({
        showToast: true,
        message: "読み込みに失敗しました",
        state: 1,
        timeout: 2000,
      });
      setTimeout(() => {
        router.back();
      }, 3000);
    }, 1000);
  } else {
    // 応募ステータスが案件応募前、キャンセルの場合は案件詳細画面にリダイレクトする
    if (res.aplication_state == APPLICATION_STATE.BEFORE_APPLY || res.aplication_state == APPLICATION_STATE.CANCELED || res.aplication_state == APPLICATION_STATE.CANNOT_APPLY) {
      omiStore.setSelectedTab(0)
      router.replace("/project-detail");
    }
    detail.value = res;
    checkDifference();
    document.title = res.title;
    if (new Date(detail.value.entry_ended_at) < new Date()) {
      isEntryEnd.value = true;
    }
    loading.value = false;
  }
});

// 案件詳細 ステータス最新に更新
async function updateProjectDetail() {
  loading.value = true;
  detail.value = await omiStore.getProjectDetail();
  await nextTick(() => {
    loading.value = false;
  });
  checkDifference();
}

/** 案件詳細で表示されているステータスと一覧で表示されているステータスに差異があれば一覧の方を更新する */
function checkDifference() {
  // 応募中一覧/進行中一覧に表示されているステータスと案件詳細で表示されているステータスが違った場合、応募中一覧/進行中一覧の方を更新する
  const targetProject = omiStore.appliedProjectList
    .get(omiStore.selectedStatus)
    ?.find((v) => v.id == detail.value.id);
  if (
    targetProject &&
    targetProject.aplication_state != detail.value.aplication_state
  ) {
    // 応募中から当選済にステータスが変わった時
    if (APPLICATION_STATE.WON == detail.value.aplication_state) {
      omiStore.updateAppliedToProgressProject(detail.value);
    } else if (
      APPLICATION_STATE.WAITING_FOR_ITEM <= detail.value.aplication_state &&
      detail.value.aplication_state <= APPLICATION_STATE.CHECKING_POST
    ) {
      // 進行中案件に表示されている応募ステータスを更新する
      omiStore.updateProgressProject();
      // もし、商品送付もしくは下書き送信がない場合は応募中一覧も更新する
      if (
        targetProject.aplication_state == APPLICATION_STATE.APPLIED &&
        (!detail.value.is_needed_review || !detail.value.has_shipment)
      ) {
        omiStore.updateAppliedToProgressProject(detail.value);
      }
    } else if (
      APPLICATION_STATE.WAITING_FOR_PAID <= detail.value.aplication_state &&
      detail.value.aplication_state <= APPLICATION_STATE.CANCELED
    )
      // 進行中案件に表示されている応募ステータスを更新する/ 応募中一覧にある案件を更新（キャンセルのため削除）する
      omiStore.updateProgressToDoneProject(detail.value.aplication_state);
  }
  // 三条書面一覧もストアの更新が必要であれば更新する
  if (
    omiStore.documentList?.find((v) => v.id == detail.value.id)
      ?.aplication_state != detail.value.aplication_state
  ) {
    // 進行中案件に表示されている応募ステータスを更新する
    omiStore.updateDocumentsProject(detail.value);
  }
}
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/_mixin.scss";
@mixin p__defalut($size, $line_height) {
  // font-family: $font-family-hiragino-gothic-pron;
  font-style: normal;
  font-weight: 300;
  font-size: $size;
  line-height: $line_height;
  color: #333333;
  margin: 0;
}
html {
  overscroll-behavior: none;
}
.project-detail {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  // padding-bottom: 200px;
  margin: 0 auto;
  background-color: $white;
  font-size: $FONT_SIZE_M;
  line-height: 21px;
  color: #333333;
  white-space: pre-line;
  .toast {
    @include toast();
  }
  .status__list {
    padding-bottom: 10px;
    span {
      font-style: normal;
      font-weight: 600;
      font-size: $FONT_SIZE_M;
      line-height: 21px;

      color: #000000;
    }
    img {
      padding-right: 15px;
    }
  }
  .current_status__list {
    padding-bottom: 10px;
    padding-top: 19px;
    padding-bottom: 24px;
    span {
      font-style: normal;
      font-weight: 600;
      font-size: $FONT_SIZE_M;
      line-height: 21px;

      color: #000000;
    }
    img {
      padding-right: 15px;
    }
    .current__status {
      -webkit-animation: blink 1.5s ease-in-out infinite alternate;
      -moz-animation: blink 1.5s ease-in-out infinite alternate;
      animation: blink 1.5s ease-in-out infinite alternate;
    }
    background-color: rgba(251, 251, 251, 1);
  }

  .footer {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    text-align: center;
    position: fixed;
    bottom: 80px;
    z-index: 999;
    // scroll-behavior: 60px;
  }
}
.project-detail::-webkit-scrollbar {
  display: none;
}

@-webkit-keyframes blink {
  0% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes blink {
  0% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes blink {
  0% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
ul {
  padding: 16px 0;
}
hr {
  height: 0px;
  margin: 0 16px;
  border: 1px solid #ececec;
}

.p__style__3 {
  @include p__defalut($FONT_SIZE_S, 18px);
}
.p__style__4 {
  @include p__defalut($FONT_SIZE_M, 21px);
}

.loading {
  display: flex;
  position: relative;
  justify-content: center;
  top: 50%;
  img {
    width: 10%;
    height: 10%;
  }
}
.warnig-banner {
  width: 100%;
  border-radius: 2px;
  align-content: center;
  background-color: orange;
  height: 60px;
}
.l-modal__bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 999;
}
.contact {
  padding: 50px 0 333px 0;
}
.done {
  border-left: solid rgb(8, 110, 182) 1px;
  margin-left: 8px;
}
.undone {
  border-left: 1px dashed #086eb6;
  margin-left: 8px;
}
.status-message {
  padding-left: 23px;
}
.list__item {
  @include menu-list-item();
}
.list__item__area {
  border-top: 1px solid $grey;
  padding-bottom: 250px;
}
.state-condition {
  padding-bottom: 27px;
  padding-left: 21px;
  padding-top: 25px;
}
</style>
